module.exports = __webpack_public_path__ + "static/media/upload_bg.647ef297.svg";